import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteCheckoutPage = createSelector(getCurrentRoute, (current) => current?.url?.startsWith('/checkout') || false);
